import GradientBackdrop from "../../../../common/GradientBackdrop";

const BACKDROP_HEIGHT = 365;

const EmailBackdrop = ({ bgColor, backdropElementRef }) => {
  return (
    <div
      ref={backdropElementRef}
      className="qr-backdrop"
      style={{ "--height": `${BACKDROP_HEIGHT}px` }}
    >
      <GradientBackdrop bgColor={bgColor} />
    </div>
  );
};

export default EmailBackdrop;
